import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {GlobalService} from '../../service/global.service';
import {AutenticacaoApiService} from '../../service/api/autenticacao.api';
import {Usuario} from '../../model/usuario';
import {ModalService} from '../../service/modal.service';
import {environment} from '../../environments/environment';
import { CookieService } from 'ngx-cookie';

@Component({
    selector: 'login',
    templateUrl: './login.html',
    styleUrls: ['./login.css']
})
export class LoginComponent implements OnInit {

    versao: string;
    mensagens: String;
    erroChave: Boolean;
    erroSenha: Boolean;

    chave = new FormControl('', [Validators.required]);
    senha = new FormControl('', []);
    certificado = new FormControl(false, []);

    loginForm: FormGroup = this.formBuilder.group({
        chave: this.chave,
        senha: this.senha,
        certificado: this.certificado
    });

    constructor(
        private formBuilder: FormBuilder, public modalService: ModalService, 
        private router: Router, private autenticacaoApiService: AutenticacaoApiService, 
        public globalService: GlobalService, private cookieService: CookieService, private activatedRoute: ActivatedRoute, ) {
    }

    ngOnInit() {

        if (this.globalService.autenticado) {
            this.router.navigate(['/catalogo']);
            return;
        } else {
            let usuarioCookie = <Usuario>this.cookieService.getObject('usuarioCadastro');
            let refreshToken: any;
            if (usuarioCookie === null || usuarioCookie === undefined) {
              this.activatedRoute.params.subscribe(
                params => {
                    refreshToken = params['refresh-token'];
                }
            );
            if ( refreshToken != '' && refreshToken != undefined ) {
            let dados = this.globalService.renovarToken(refreshToken)
            .subscribe(
                usuarioToken => {
                const now = new Date();
                this.globalService.usuario = new Usuario();
                this.globalService.usuario.access_token = usuarioToken.access_token;
                this.globalService.usuario.data_expiracao = usuarioToken.data_expiracao;
                this.globalService.usuario.emitido_em = now.getTime().toString();
                this.globalService.loginUsuario(usuarioToken);
                this.globalService.loading = false;
                this.globalService.fecharModalLogin();
                this.router.navigate(['/catalogo']);
                },
                error => {
                this.globalService.timedOut = true;
                this.globalService.logoutUsuario();
                this.globalService.loading = false;
                this.globalService.abrirModalLogin();
                }
            );
        }}

        }

        this.modalService.fecharPaginaModal();
        this.versao = environment.version;
    }

    loginUsuario() {

        this.chave.value == '' ? this.erroChave = true : this.erroChave = false;
        if (this.certificado.value == false) {
            this.senha.value == '' ? this.erroSenha = true : this.erroSenha = false;
        } else {
            this.erroSenha = false;
        }

        if (this.erroChave || this.erroSenha) {
            return null;
        }

        this.globalService.loading = true;
        let username = this.chave.value;
        let password = this.senha.value;
        let scope = environment.api_escopo;

        this.mensagens = null;

        this.autenticacaoApiService.loginUsuario(username, password, scope, this.certificado.value, '')
            .subscribe(
                (usuario) => {
                    const scopes = usuario.scope.split(' ') || [];
                    if (scopes.length === 1 && scopes[0] === 'sia:usuario') {
                        this.mensagens = "Usuário não possui permissões suficientes.";
                        this.globalService.loading = false;
                        this.globalService.fecharModalLogin();
                        return;
                    }

                    this.globalService.loginUsuario(usuario);
                    this.router.navigate(['/catalogo']);
                },
                (erro) => {
                    console.error('Erro autenticação');
                    this.globalService.loading = false;
                    var erroJson;
                    erroJson = <any>erro;
                    if (erro.status == 400) {
                        if (erroJson) {
                            this.mensagens = erroJson.error_description;
                        }
                    } else if (erro.status == 401) {
                        this.mensagens = 'Usuário inválido ou senha incorreta.';
                    } else if (erro.status == 403) {
                        this.mensagens = 'Solicitar ACESSO-11-01 Aplicativo GMT';
                    } else if (erro.status == 404) {
                        this.mensagens = 'Servidor não respondendo';
                    } else if (erro.status == 500) {
                        if (erroJson) {
                            this.mensagens = erroJson.error_description;
                        }
                    } else {
                        this.mensagens = 'Falha no login';
                    }

                },
                () => console.log('Autenticação realizada')
            );

        this.globalService.fecharModalLogin();
    }

    pulaProximoCampo(event: any, focusable: any) {
        let chave = event.target.value;
        chave = chave.toLowerCase();
        if (chave.length == 8 && (chave.charAt(0) == 'f' || chave.charAt(0) == 'j' || chave.charAt(0) == 'c') && /^\d+$/.test(chave.substr(1, 7))) {
            focusable.focus();
        }
    }

    certificadoCheck() {
        if (this.certificado.value == true) {
            this.senha.disable();
        } else {
            this.senha.enable();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts